import React from "react";
import { ObrasPage } from "./obras.page";
import { ObrasProvider } from "./context/obras-context";

export function ObrasFactory() {
    return (
        <ObrasProvider>
            <ObrasPage></ObrasPage>
        </ObrasProvider>
    );
}
